/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './sexual-history.reducer';

export const SexualHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const sexualHistoryEntity = useAppSelector(state => state.sexualHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="sexualHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.sexualHistory.detail.title">SexualHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.id}</dd>
          <dt>
            <span id="solo">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.solo">Solo</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.solo ? 'true' : 'false'}</dd>
          <dt>
            <span id="partner">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.partner">Partner</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.partner ? 'true' : 'false'}</dd>
          <dt>
            <span id="currMethod">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.currMethod">Curr Method</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.currMethod}</dd>
          <dt>
            <span id="currMethodSatisfaction">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.currMethodSatisfaction">Curr Method Satisfaction</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.currMethodSatisfaction}</dd>
          <dt>
            <span id="pastMethodHistory">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.pastMethodHistory">Past Method History</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.pastMethodHistory}</dd>
          <dt>
            <span id="sexuallyActive">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.sexuallyActive">Sexually Active</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.sexuallyActive ? 'true' : 'false'}</dd>
          <dt>
            <span id="activeNumPartners">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.activeNumPartners">Active Num Partners</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.activeNumPartners}</dd>
          <dt>
            <span id="newPartnerInThreeMonths">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.newPartnerInThreeMonths">New Partner In Three Months</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.newPartnerInThreeMonths ? 'true' : 'false'}</dd>
          <dt>
            <span id="contraception">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.contraception">Contraception</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.contraception}</dd>
          <dt>
            <span id="historyOfSexualAbuse">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.historyOfSexualAbuse">History Of Sexual Abuse</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.historyOfSexualAbuse ? 'true' : 'false'}</dd>
          <dt>
            <span id="abuseComments">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.abuseComments">Abuse Comments</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.abuseComments}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.sexualHistory.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{sexualHistoryEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.sexualHistory.patient">Patient</Translate>
          </dt>
          <dd>{sexualHistoryEntity.patient ? sexualHistoryEntity.patient.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/sexual-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/sexual-history/${sexualHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SexualHistoryDetail;
